module.exports = __webpack_public_path__ + "static/img/technologybimg1.cf63141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/technologybimg1.jpg
// module id = dbPS
// module chunks = 2